import React, { useEffect, useState } from "react";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import { Showalert } from "../../../../customComponents/CustomSweetAlert/SweetAlert";
import Swal from "sweetalert2";
const AddNewLead = () => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [leadPriorityOptions, setLeadPriorityOptions] = useState([]);
  const [executiveoptions, setExecutiveOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [oldproductOptions, setOldProductOptions] = useState([]);
  const [titleoptions, settitleOptions] = useState([]);
  const [OccupationOptions, setOccupationOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [oldvariantOptions, setOldVariantOptions] = useState([]);
  const [customertypeOptions, setCustomerTypeOptions] = useState([]);
  const [showroomOptions, setshowroomOptions] = useState([]);
  const [BusinessPartneroptions, setBusinessPartneroptions] = useState([]);
  const [statusoptions, setstatusOptions] = useState([]);
  const [languageoptions, setlanguageOptions] = useState([]);
  const [fuelOptions, setFuelOptions] = useState([]);

  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [branchCenteroptions, setBranchCenterOptions] = useState([]);
  const location = useLocation();
  const lead_id = location?.state?.data?.lead_id;
  const dealer_id = localStorage.getItem("dealerId");
  const userType = localStorage.getItem("UserType");
  const [BUSINESSPARTNERID, SETBUSINESSPARTNERID] = useState();
  console.log("usertype", userType);

  const business_partner_id = localStorage.getItem("business_partner_id");

  const currentDate = new Date();
const min18YearsAgo = new Date(
  currentDate.getFullYear() - 18,
  currentDate.getMonth(),
  currentDate.getDate()
);
  const CustomerInputs = [
    {
      name: "leadsource",
      label: "Lead Source",
      type: "dropdown",
      required: true,
      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "customertype",
      label: "Customer Type",
      type: "dropdown",
      //required: true,
      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "title",
      label: "Title",
      type: "dropdown",
      required: false,
      // validation:{required:true},
      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "firstname",
      label: "First Name",
      type: "text",
      required: true,
      placeholder: "Enter First Name",
      validation: {
        required: true,
        pattern: /^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/,
        message: "Invalid First Name",
        maxLength: 25,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "lastname",
      label: "Last Name",
      type: "text",
      placeholder: "Enter Last Name",
      required: true,
      validation: {
        required: true,
        pattern:  /^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/,
        message: "Invalid Last Name.",
        maxLength: 25,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "mobile",
      label: "Mobile No.",
      type: "text",
      required: true,
      placeholder: "Enter Mobile Number",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "altmobile",
      label: "Alternate Mobile No.",
      type: "text",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      },

      gridClass: "col-lg-4",
    },
    {
      name: "email",
      label: "Email Address",
      type: "text",
      placeholder: "Enter Email Address",
      required: false,
      validation: {
        
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Please enter a valid Email Address",
      },

      gridClass: "col-lg-4",
    },
    {
      name: "dob",
      label: "DOB",
      type: "date",
      maxDate: min18YearsAgo,
      required: false,
      placeholder: "Enter Date Of Birth",
      gridClass: "col-lg-4",
    },
    {
      name: "panno",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter PAN No.",
      validation: {
        required: false,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Please enter a valid 10-character PAN number",
      },
      required: false,
      gridClass: "col-lg-4",
    },
    {
      name: "gstno",
      label: "GST No.",
      type: "text",
      placeholder: "Enter GST No.",
      validation: {
        required: false,
        pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
        message: "Please enter a valid 15-character GST number",
        maxLength: 15,
      },
      required: false,
      gridClass: "col-lg-4",
    },
    {
      name: "adhaar",
      label: "Aadhaar No.",
      type: "text",
      placeholder: "Enter Aadhaar No.",
      validation: {
        required: false,
        pattern: /^\d{12}$/,
        message: "Please enter a valid 12-digit Aadhar number",
        maxLength: 12,
      },
      required: false,

      gridClass: "col-lg-4",
    },
    {
      name: "pincode",
      label: "Pin Code",
      type: "number",
      placeholder: "Enter Pin Code",
      gridClass: "col-lg-4",
      validation: {
        required: false,
        message: "PinCode is required",
        maxLength: 6,
      },
    },
    {
      name: "city",
      label: "City",
      type: "text",
      required: false,
      placeholder: "City",
      disabled: true,
      //options:[],
      gridClass: "col-lg-4",
    },
    {
      name: "state",
      label: "State",
      type: "text",
      placeholder: "State",
      required: false,
      disabled: true,
      gridClass: "col-lg-4",
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      placeholder: "Country",
      required: false,
      disabled: true,
      gridClass: "col-lg-4",
    },

    {
      name: "address",
      label: "Address",
      type: "text",
      required: false,
      placeholder: "Enter Address",
      gridClass: "col-lg-4",
    },

    {
      name: "occupation",
      label: "Occupation",
      type: "dropdown",
      required: false,
      options: [],
      gridClass: "col-lg-4",
    },

    {
      name: "productname",
      label: "Product",
      type: "dropdown",
      required: false,
      options: [],
      placeholderL: "Enter Product Name",
      gridClass: "col-lg-4",
    },
    {
      name: "vehiclename",
      label: "Vehicle Name(Variant type)",
      type: "dropdown",
      required: false,
      options: [],

      gridClass: "col-lg-4",
    },

    {
      name: "make",
      label: "Make",
      type: "text",
      disabled: true,
      required: false,
      placeholder: "Enter Make Name",
      gridClass: "col-lg-4",
    },
    {
      name: "model",
      label: "Model",
      type: "text",
      required: false,
      placeholder: "Enter Model Name",
      disabled: true,
      gridClass: "col-lg-4",
    },
    {
      name: "fueltype",
      label: "Fuel Type",
      type: "text",
      required: false,
      disabled: true,
      //options:[],
      placeholder: "Enter Fuel  Type",
      gridClass: "col-lg-4",
    },
    {
      name: "color",
      label: "Color",
      type: "text",
      required: false,
      placeholder: "Enter Color",
      disabled: true,
      gridClass: "col-lg-4",
    },

    {
      name: "exshowroomprice",
      label: "EX-Showroom Price",
      type: "text",
      placeholder: "Enter EX-Showroom Price",
      required: false,
      disabled: true,

      gridClass: "col-lg-4",
    },
    {
      name: "financerequired",
      label: "Finance Required",
      type: "toggle",
      required: false,
      options: [{ label: "Finance Required", value: 1 }],
      gridClass: "col-lg-4",
    },
    {
      name: "vehicledemorequired",
      label: "Vehicle Demo Required",
      type: "toggle",
      required: false,
      options: [{ label: "Finance Required", value: 1 }],
      gridClass: "col-lg-4",
    },
    {
      name: "buyback",
      label: "Would you want buy back",
      type: "toggle",
      required: false,
      options: [{ label: "Would you want buy back", value: 1 }],
      gridClass: "col-lg-4",
    },
    {
      name: "exchange",
      label: "Exchange",
      type: "toggle",
      required: false,
      options: [{ label: "Finance Required", value: 1 }],
      gridClass: "col-lg-4",
    },
    {
      name: "oldproduct",
      label: "Old Product",
      type: "dropdown",
      isVisible: false,
      required: false,

      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "oldvehiclename",
      label: "Old Vehicle Name(Variant type)",
      type: "dropdown",
      required: false,
      options: [],
      isVisible: false,
      gridClass: "col-lg-4",
    },

    // {
    //   name: "oldsubproduct",
    //   label: "Old SubProduct",
    //   type: "dropdown",
    //   required: true,
    //   isVisible:false,
    //   options:[],
    //   gridClass: "col-lg-4",
    // },
    {
      name: "oldmake",
      label: "Old Make",
      type: "text",
      required: false,
      isVisible: false,
      disabled:true,
      placeholder: "Enter Old Make Name",
      gridClass: "col-lg-4",
    },
    {
      name: "oldmodel",
      label: "Old Model",
      type: "text",
      required: false,
      disabled:true,
      placeholder: "Enter Old Model Name",
      isVisible: false,

      gridClass: "col-lg-4",
    },
    {
      name: "leadexecutive",
      label: "Lead Executive",
      type: "dropdown",
      required: false,

      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "leadpriority",
      label: "Lead Priority",
      type: "dropdown",
      required: true,
      validation: { required: true },
      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "preferredlanguage",
      label: "Preferred Language",
      type: "dropdown",
      required: false,
      options: [],
      gridClass: "col-lg-4",
    },

    {
      name: "branchcity",
      label: "Branch City",
      type: "dropdown",
      required: false,
      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      required: true,
      placeholder: "Enter Remark",

      gridClass: "col-lg-4",
    },
    {
      name: "branchcenter",
      label: "Branch Center",
      type: "dropdown",
      required: false,
      options: [],
      gridClass: "col-lg-4",
    },

    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "open", value: "Open" },
        { label: "lost", value: "Lost" },
        { label: "won", value: "Won" },
      ],
      gridClass: "col-lg-4",
    },
  ];
  // const CustomerInputs = [

  //   {
  //     name: "leadsource",
  //     label: "Lead Source",
  //     type: "dropdown",
  //     required: true,
  //     options: [

  //       ],
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "customertype",
  //     label: "Customer Type",
  //     type: "dropdown",
  //     required: true,
  //     options: [

  //       ],
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "title",
  //     label: "Title",
  //     type: "dropdown",
  //     required: true,
  //     options: [

  //       ],
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "firstname",
  //     label: "First Name",
  //     type: "text",
  //     required: true,
  //     placeholder:"Enter First Name",
  //     validation: { required: true,pattern: /^[a-zA-Z]+$/, message: "Only Alphabets Are Allowed*", maxLength: 15 },
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "lastname",
  //     label: "Last Name",
  //     type: "text",
  //     placeholder:"Enter Last Name",
  //     required: true,
  //     validation: { required: true,pattern: /^[a-zA-Z]+$/, message: "Only Alphabets Are Allowed*" , maxLength: 15},
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "mobile",
  //     label: "Mobile No.",
  //     type: "text",
  //     required: true,
  //     placeholder:"Enter Mobile Number",
  //    validation: { required: true, pattern: /^[0-9]{10}$/ , message: "Please enter a valid 10-digit mobile number", maxLength: 10},
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "altmobile",
  //     label: "Alternate Mobile No.",
  //     type: "text",
  //      isVisible: false,
  //    validation: { required: false, pattern: /^[0-9]{10}$/ , message: "Please enter a valid 10-digit mobile number" , maxLength: 10},

  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "email",
  //     label: "Email Address",
  //     type: "text",
  //     placeholder:"Enter Email Address",
  //     required: true,
  //     validation: { required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ , message: "Please enter a valid Email Address"},

  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "dob",
  //     label: "DOB",
  //     type: "date",
  //     required: true,
  //    placeholder:"Enter Date Of Birth",
  //     gridClass: "col-lg-4",
  //   },
  //    {
  //   name: "panno",
  //   label: "PAN No.",
  //   type: "text",
  //   placeholder: "Enter PAN No.",
  //   validation: {
  //     required: false,
  //     pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
  //     message: "Please enter a valid 10-character PAN number",
  //     maxLength: 10
  //   },
  //   required: false,
  //   gridClass: "col-lg-4",
  // },
  // {
  //   name: "gstno",
  //   label: "GST No.",
  //   type: "text",
  //   placeholder: "Enter GST No.",
  //   validation: {
  //     required: false,
  //     pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
  //     message: "Please enter a valid 15-character GST number",
  //    maxLength: 15
  //   },
  //   required: false,
  //   gridClass: "col-lg-4",
  // },
  //   {
  //     name: "adhaar",
  //     label: "Aadhaar No.",
  //     type: "text",
  //     placeholder:"Enter Aadhar No.",
  //      validation: {
  //     required: false,
  //     pattern: /^\d{12}$/,
  //     message: "Please enter a valid 12-digit Aadhar number"
  //   },
  //     required: false,

  //     gridClass: "col-lg-4",
  //   },

  //   {
  //     name: "pincode",
  //     label: "Pincode",
  //     type: "text",
  //     required: true,
  //     placeholder:"Enter Pincode",
  //     gridClass: "col-lg-4",
  //     validation: {
  //       required: true,
  //       maxLength:6
  //     }
  //   },
  //   {
  //     name: "city",
  //     label: "City",
  //     type: "text",
  //     required: true,
  //     placeholder:"Enter City",
  //      disabled:true,
  //     //options:[],
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "state",
  //     label: "State",
  //     type: "text",
  //     placeholder:"Enter State",
  //     required: true,
  //     disabled:true,
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "country",
  //     label: "Country",
  //     type: "text",
  //     placeholder:"Enter Country",
  //     required: true,
  //     disabled:true,
  //     gridClass: "col-lg-4",
  //   },

  //   {
  //     name: "address",
  //     label: "Address",
  //     type: "text",
  //     required: true,
  //    placeholder:"Enter Address",
  //     gridClass: "col-lg-4",
  //   },

  //   {
  //     name: "occupation",
  //     label: "Occupation",
  //     type: "dropdown",
  //     required: true,
  //    options:[],
  //     gridClass: "col-lg-4",
  //   },

  //   {
  //     name: "productname",
  //     label: "Product",
  //     type: "dropdown",
  //     required: true,
  //     options: [],
  //     placeholderL:"Enter Product Name",
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "vehiclename",
  //     label: "Vehicle Name(Variant type)",
  //     type: "dropdown",
  //     required: true,
  //     options:[],

  //     gridClass: "col-lg-4",
  //   },

  //   {
  //     name: "make",
  //     label: "Make",
  //     type: "text",
  //     disabled:true,
  //     required: true,
  //    placeholder:"Enter Make Name",
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "model",
  //     label: "Model",
  //     type: "text",
  //     required: true,
  //     placeholder:"Enter Model Name",
  //     disabled:true,
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "fueltype",
  //     label: "Fuel Type",
  //     type: "text",
  //     required: true,
  //     disabled:true,
  //     //options:[],
  //     placeholder:"Enter Fuel  Type",
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "color",
  //     label: "Color",
  //     type: "text",
  //     required: true,
  //     placeholder:"Enter Color",
  //     disabled:true,
  //     gridClass: "col-lg-4",
  //   },

  //   {
  //     name: "exshowroomprice",
  //     label: "EX-Showroom Price",
  //     type: "text",
  //     placeholder:"Enter EX-Showroom Price",
  //     required: true,
  //     disabled:true,

  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "financerequired",
  //     label: "Finance Required",
  //     type: "toggle",
  //     required: true,
  //    options:[{ label: "Finance Required", value: 1 },],
  //     gridClass: "col-lg-2",
  //   },
  //   {
  //     name: "vehicledemorequired",
  //     label: "Vehicle Demo Required",
  //     type: "toggle",
  //     required: true,
  //    options:[{ label: "Finance Required", value: 1 },],
  //     gridClass: "col-lg-2",
  //   },
  //   {
  //     name:"buyback",
  //     label: "Would you want buy back",
  //     type: "toggle",
  //     required: true,
  //    options:[{ label: "Would you want buy back", value: 1 },],
  //     gridClass: "col-lg-2",
  //   },
  //   {
  //     name: "exchange",
  //     label: "Exchange",
  //     type: "toggle",
  //     required: true,
  //    options:[{ label: "Finance Required", value: 1 },],
  //     gridClass: "col-lg-2",
  //   },
  //   {
  //     name: "oldproduct",
  //     label: "Old Product",
  //     type: "dropdown",
  //     isVisible:false,
  //     required: true,

  //     options:[],
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "oldvehiclename",
  //     label: "Old Vehicle Name(Variant type)",
  //     type: "dropdown",
  //     required: true,
  //     options:[],
  //     isVisible:false,
  //     gridClass: "col-lg-4",
  //   },

  //   // {
  //   //   name: "oldsubproduct",
  //   //   label: "Old SubProduct",
  //   //   type: "dropdown",
  //   //   required: true,
  //   //   isVisible:false,
  //   //   options:[],
  //   //   gridClass: "col-lg-4",
  //   // },
  //   {
  //     name: "oldmake",
  //     label: "Old Make",
  //     type: "text",
  //     required: true,
  //     isVisible:false,
  //    placeholder:"Enter Old Make Name",
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "model",
  //     label: "Old Model",
  //     type: "text",
  //     required: true,
  //     placeholder:"Enter Old Model Name",
  //     isVisible:false,

  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "leadexecutive",
  //     label: "Lead Executive",
  //     type: "dropdown",
  //     required: true,

  //     options:[],
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "leadpriority",
  //     label: "Lead Priority",
  //     type: "dropdown",
  //     required: true,
  //     options:[],
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "preferredlanguage",
  //     label: "Preffered Language",
  //     type: "dropdown",
  //     required: true,
  //     options:[],
  //     gridClass: "col-lg-4",
  //   },
  //   ...(userType === "superadmin"
  //     ? [
  //         {
  //           name: "businesspartnername",
  //           label: "Business Partner",
  //           type: "dropdown",
  //           required: true,
  //           options: [],
  //           gridClass: "col-lg-4",
  //           validation: {
  //             required: true,
  //             pattern: /^[A-Za-z0-9 ]*$/,
  //             message: "Only alphabets and digits are allowed",
  //           },
  //         },
  //       ]
  //     : []),

  //   {
  //     name: "branchcity",
  //     label: "Branch City",
  //     type: "dropdown",
  //     required: true,
  //     options:[],
  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "remark",
  //     label: "Remark",
  //     type: "text",
  //     required: true,
  //     placeholder:"Enter Remark",

  //     gridClass: "col-lg-4",
  //   },
  //   {
  //     name: "branchcenter",
  //     label: "Branch Center",
  //     type: "dropdown",
  //     required: true,
  //     options:[],
  //     gridClass: "col-lg-4",
  //   },

  //   {
  //     name: "status",
  //     label: "status Name",
  //     type: "dropdown",
  //     required: true,
  //     options: [
  //         { label: "open", value: "Open" },
  //         { label: "lost", value: "Lost" },
  //         { label: "won", value: "Won" },

  //       ],
  //     gridClass: "col-lg-4",
  //   },

  // ];

  //console.log("location",locationData);
  useEffect(() => {
    const fetchLeadData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axiosInstance.get(
          `/lead/lead-details/${lead_id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const leadData = response.data?.data?.data[0];
        console.log("leadData", leadData);
        SETBUSINESSPARTNERID(leadData?.business_partner_id);
        setFormData({
          oldvehiclename:leadData?.existing_variant_id,  
          occupation: leadData?.occupation_id,
          leadsource: leadData?.source_id,
          customertype: leadData?.customer_type_id,
          title: leadData?.title_id,
          firstname: leadData?.first_name,
          dob: leadData?.dob,
          lastname: leadData?.last_name,
          pincode: leadData?.pincode,
          state: leadData?.country,
          state: leadData?.state,
          city: leadData?.city,
          // variant_id:leadData?.variant_id,
          panno: leadData?.pan_no,
          adhaar: leadData?.aadhar_no,
          gstno: leadData?.gst_no,
          mobile: leadData?.mobile_no,
          email: leadData?.email_id,
          address: leadData?.address,
          productname: leadData?.product_id,
          make: leadData?.make_name,
          model: leadData?.model_name,
          branchcenter:leadData?.showroom_id,
          branchcity:leadData?.showroom_city_id,
          financerequired: leadData?.finance_required == 0 ? false : true,
          exchange: leadData?.exchange == 0 ? false : true,
          vehicledemorequired:leadData?.vehicle_demo_required,
          buyback:leadData?.wouldyouwantbuyback,
          vehiclename: leadData?.variant_id,
          color: leadData?.color_name,
          leadpriority: leadData?.priority_id,
          oldproduct:leadData?.existing_product_id, 
         // oldvehiclename:leadData?.existing_variant_id?leadData?.existing_variant_id:leadData?.existing_variant_id,
          oldmake:leadData?.existingmake_name,
          oldmodel:leadData?.existingmodel_name,
          remark: leadData?.remarks,
          leadexecutive: leadData?.lead_executive_id,
          preferredlanguage: leadData.language_id,
         
          status: leadData?.status_id,

        });
      } catch (error) {
        console.error("Error fetching lead data:", error);
      }
    };

    if (lead_id) {
      fetchLeadData();
    }
  }, [lead_id]);

  useEffect(() => {
    if (formData.oldproduct) {
      const fetchVariantOptions = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const response = await axiosInstance.post(
            "/variant/ddlvariant",
            {
              business_partner_id: BUSINESSPARTNERID,
              product_id: formData.oldproduct,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const variantOptions = response.data.data.data?.map((variant) => ({
            label: variant.NAME,
            value: variant.ID,
          }));

          setVariantOptions(variantOptions);
          setOldVariantOptions(variantOptions);
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchVariantOptions();
    }
  }, [formData.oldproduct]);

  useEffect(() => {
    if (formData.productname) {
      const fetchVariantOptions = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const response = await axiosInstance.post(
            "/variant/ddlvariant",
            {
              business_partner_id: BUSINESSPARTNERID,
              product_id: formData.productname,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const variantOptions = response.data.data.data?.map((variant) => ({
            label: variant.NAME,
            value: variant.ID,
          }));

          setVariantOptions(variantOptions);
          //setOldVariantOptions(variantOptions);
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchVariantOptions();
    }
  }, [formData.productname]);
  useEffect(() => {
    if (formData.oldvehiclename) {
      const fetchOldVariantBasedDetails = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const response = await axiosInstance.post(
            "/variant/ddlvariantbasedetails",
            {
              //business_partner_id:BUSINESSPARTNERID,
              variant_id: formData.oldvehiclename,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const variantwisedata = response?.data?.data?.data[0];
          console.log("variantwisedata", variantwisedata);
   setFormData({
            ...formData,
            oldmake: variantwisedata?.make_name,
            oldmodel: variantwisedata?.model_name,
           
          });
          // const variantOptions = response.data.data.data?.map(variant => ({
          //   label:variant.NAME,
          //   value: variant.ID,
          // }));

          // setVariantOptions(variantOptions);
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchOldVariantBasedDetails();
    }
  }, [formData.oldvehiclename]);

  useEffect(() => {
    if (formData.vehiclename) {
      const fetchVariantBasedDetails = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const response = await axiosInstance.post(
            "/variant/ddlvariantbasedetails",
            {
              //business_partner_id:BUSINESSPARTNERID,
              variant_id: formData.vehiclename,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const variantwisedata = response?.data?.data?.data[0];
          console.log("variantwisedata", variantwisedata);

          setFormData({
            ...formData,

            fueltype: variantwisedata?.fuel_type_name,
            make: variantwisedata?.make_name,
            model: variantwisedata?.model_name,
            exshowroomprice: variantwisedata?.exshowroom_price,
            color: variantwisedata?.color_name,
          });
          // const variantOptions = response.data.data.data?.map(variant => ({
          //   label:variant.NAME,
          //   value: variant.ID,
          // }));

          // setVariantOptions(variantOptions);
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchVariantBasedDetails();
    }
  }, [formData.vehiclename]);

  useEffect(() => {
    if (BUSINESSPARTNERID) {
      fetchOptions();
    }
  }, [BUSINESSPARTNERID]);
  useEffect(() => {
    if (formData.branchcity) {
      const fetchCityBasedShowroom = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const response = await axiosInstance.post(
            "/showroom/ddlshowroom",
            {
              business_partner_id: BUSINESSPARTNERID,
              city_id: formData.branchcity,
              dealer_id: dealer_id === "null" ? null : dealer_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const options = response.data.data.data?.map((source) => ({
            label: source.NAME,
            value: source.ID,
          }));
          setBranchCenterOptions(options);
          console.log(options, "BranchOptions");

          // setVariantOptions(variantOptions);
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchCityBasedShowroom();
    }
  }, [formData.branchcity]);

  const fetchOptions = async () => {
    console.log("Business", BUSINESSPARTNERID);

    if (BUSINESSPARTNERID) {
      try {
        const token = localStorage.getItem("authToken");

        const leadSourceResponse = await axiosInstance.post(
          "/source/ddlsource",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const options = leadSourceResponse.data.data.data?.map((source) => ({
          label: source.NAME,
          value: source.ID,
        }));

        setLeadSourceOptions(options);

        const customerTypeResponse = await axiosInstance.post(
          "/customertype/ddlcustomertype",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const CustomerTypeoptions = customerTypeResponse.data.data.data?.map(
          (customer) => ({
            label: customer.NAME,
            value: customer.ID,
          })
        );
        console.log("options>>>", CustomerTypeoptions);

        setCustomerTypeOptions(CustomerTypeoptions);

        const BusinessPartenerResponse = await axiosInstance.get(
          "/bp-onboard/bplist",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const Businessoptions = BusinessPartenerResponse.data.data.data?.map(
          (customer) => ({
            label: customer.bp_name,
            value: customer.onboard_id,
          })
        );

        setBusinessPartneroptions(Businessoptions);

        const titleResponse = await axiosInstance.post(
          "/title/ddltitle",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const titleoptions = titleResponse.data.data.data?.map((customer) => ({
          label: customer.NAME,
          value: customer.ID,
        }));

        settitleOptions(titleoptions);
        const FuelResponse = await axiosInstance.post(
          "/fueltype/ddlfueltype",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const fuelOptions = FuelResponse.data.data.data?.map((customer) => ({
          label: customer.NAME,
          value: customer.ID,
        }));

        setFuelOptions(fuelOptions);

        const ShowroomResponse = await axiosInstance.post(
          "/showroom/ddlShowroomcity",
          {
            business_partner_id: BUSINESSPARTNERID,
            dealer_id: dealer_id === "null" ? null : dealer_id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const showroomOptions = ShowroomResponse.data.data.data?.map(
          (customer) => ({
            label: customer.NAME,
            value: customer.ID,
          })
        );
        console.log("showroomOptions>>>", showroomOptions);

        setshowroomOptions(showroomOptions);

        const statusResponse = await axiosInstance.post(
          "/status/ddlstatus",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const statusoptions = statusResponse.data.data.data?.map(
          (customer) => ({
            label: customer.NAME,
            value: customer.ID,
          })
        );

        setstatusOptions(statusoptions);
        const languageResponse = await axiosInstance.post(
          "/language/ddllanguage",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const languageoptions = languageResponse.data.data.data?.map(
          (customer) => ({
            label: customer.NAME,
            value: customer.ID,
          })
        );

        setlanguageOptions(languageoptions);
        const occupationResponse = await axiosInstance.post(
          "/occupation/ddloccupation",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const occupationoptions = occupationResponse.data.data.data?.map(
          (customer) => ({
            label: customer.NAME,
            value: customer.ID,
          })
        );

        setOccupationOptions(occupationoptions);
        const executiveResponse = await axiosInstance.post(
          "/user/ddlleadexecutive",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const executiveoptions = executiveResponse.data.data.data?.map(
          (customer) => ({
            label: customer.NAME,
            value: customer.ID,
          })
        );

        setExecutiveOptions(executiveoptions);

        const leadPriorityResponse = await axiosInstance.post(
          "/priority/ddlpriority",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const priorityoptions = leadPriorityResponse.data.data.data?.map(
          (priority) => ({
            label: priority.NAME,
            value: priority.ID,
          })
        );

        setLeadPriorityOptions(priorityoptions);

        const productResponse = await axiosInstance.post(
          "/product/ddlproduct",
          { business_partner_id: BUSINESSPARTNERID },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const productOptions = productResponse.data.data.data?.map(
          (product) => ({
            label: product.NAME,
            value: product.ID,
          })
        );
        setProductOptions(productOptions);
        setOldProductOptions(productOptions);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    }
  };

  const navigate = useNavigate();
  const handleFormSubmit = async (data) => {
    console.log("FormData:", data);
    const errors = {};
    let isValid = true;
  
    // Form validation logic
    CustomerInputs.forEach((field) => {
      console.log("field>>", field);
      if (field.required && !data[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(data[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    // If validation fails, stop form submission
    if (!isValid) {
      setValidationErrors(errors);
      console.log("validationErrors", validationErrors);
      return;
    }
  
    // Confirmation alert before submitting
    Showalert({
      title: "Are you sure?",
      text: "Do you want to update this record?",
      icon: "warning",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      callback: async () => {
        setIsLoading(true); // Set loading to true after confirmation
  
        try {
          const token = localStorage.getItem("authToken");
          
          // Send API request to update the lead
          const response = await axiosInstance.patch(
            `/lead/updateleaddetails/${lead_id}`,
            {
              title_id: data?.title || null,
              business_partner_id: data?.businesspartnername,
              customer_type_id: data?.customertype || null,
              first_name: data?.firstname || null,
              email_id: data.email || null,
              mobile_no: data.mobile || null,
              altmobile_no: data.altmobile_no || null,
              dob: data.dob || null,
              address: data.address || null,
              occupation_id: data.occupation || null,
              language_id: data?.preferredlanguage || null,
              country_id: data.country_id || null,
              state_id: data.state_id || null,
              city_id: data.city_id || null,
              pincode: data.pincode || null,
              pan_no: data?.panno || null,
              aadhar_no: data?.adhaar || null,
              gst_no: data?.gstno || null,
              last_name: data?.lastname || null,
              business_partner_id: data?.business_partner_id
                ? business_partner_id
                : BUSINESSPARTNERID,
              source_id: data?.leadsource || null,
              product_id: data?.productname || null,
              variant_id: data?.vehiclename || null,
              lead_executive_id: data?.leadexecutive || null,
              showroom_city_id: data?.branchcity || null,
              showroom_id: data?.branchcenter,
              exshowroom_price: data?.exshowroomprice,
              finance_required: data?.financerequired == true ? 1 : 0,
              vehicle_demo_required: data?.vehicledemorequired == true ? 1 : 0,
              wouldyouwantbuyback: data?.buyback == true ? 1 : 0,
              exchange: data?.exchange == true ? 1 : 0,
              existing_product_id: data?.oldproduct || null,
              existing_variant_id: data?.oldvehiclename || null,
              priority_id: data?.leadpriority || null,
              status_id: data?.status,
              remarks: data.remark || null,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          console.log("API Response:", response.data);
  
          // Success SweetAlert with dynamic message
          Swal.fire({
            title: "Success",
            text: "Lead updated successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate(ROUTES_NAVIGATION.ADVANCESEARCH); // Navigate after user clicks OK
          });
  
        } catch (error) {
          console.error("Error submitting form:", error);
  
          // Error SweetAlert with dynamic message
          Swal.fire({
            title: "Error",
            text: error.response?.data?.message || "Failed to update the lead. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setIsLoading(false); // Reset loading state after operation
        }
      },
    });
  };
  
  // const handleFormSubmit = async (data) => {
  //   console.log("FormData:", data);
  //   const errors = {};
  //   let isValid = true;
  //   CustomerInputs.forEach((field) => {
  //     console.log("field>>", field);
  //     if (field.required && !formData[field.name]) {
  //       errors[field.name] = "This field is required";
  //       isValid = false;
  //     } else if (
  //       field.required &&
  //       field.validation &&
  //       field.validation.pattern &&
  //       !field.validation.pattern.test(formData[field.name])
  //     ) {
  //       errors[field.name] = field.validation.message;
  //       isValid = false;
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     console.log("validationErrors", validationErrors);
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     const token = localStorage.getItem("authToken");
  //     const response = await axiosInstance.patch(
  //       `/lead/updateleaddetails/${lead_id}`,
  //       {
  //         title_id: data?.title || null,
  //         business_partner_id: data?.businesspartnername,
  //         customer_type_id: data?.customertype || null,
  //         first_name: data?.firstname || null,
  //         email_id: data.email || null,
  //         mobile_no: data.mobile || null,
  //         altmobile_no: data.altmobile_no || null,
  //         dob: data.dob || null,
  //         address: data.address || null,
  //         occupation_id: data.occupation || null,
  //         language_id: data?.preferredlanguage || null,
  //         country_id: data.country_id || null,
  //         state_id: data.state_id || null,
  //         city_id: data.city_id || null,
  //         pincode: data.pincode || null,
  //         pan_no: data?.panno || null,
  //         aadhar_no: data?.adhaar || null,
  //         gst_no: data?.gstno || null,

  //         last_name: data?.lastname || null,

  //         business_partner_id: data?.business_partner_id
  //           ? business_partner_id
  //           : BUSINESSPARTNERID,
  //         source_id: data?.leadsource || null,

  //         product_id: data?.productname || null,
  //         variant_id: data?.vehiclename || null,
  //         lead_executive_id: data?.leadexecutive || null,
  //         showroom_city_id: data?.branchcity || null,
  //         showroom_id: data?.branchcenter,
  //         exshowroom_price: data?.exshowroomprice,
  //         finance_required: data?.financerequired == true ? 1 : 0,
  //         vehicle_demo_required: data?.vehicledemorequired == true ? 1 : 0,
  //         wouldyouwantbuyback: data?.buyback == true ? 1 : 0,
  //         exchange: data?.exchange == true ? 1 : 0,
  //         existing_product_id: data?.existing_product_idnull,
  //         existing_variant_id: data?.existing_variant_id || null,
  //         priority_id: data?.leadpriority || null,
  //         status_id: data?.status,
  //         existing_product_id:data?.oldproduct,
  //         existing_variant_id:data?.oldvehiclename,
  //         remarks: data.remark,
  //         status: data?.status || null,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     console.log("API Response:", response.data);

  //     navigate(ROUTES_NAVIGATION.ADVANCESEARCH);
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //   }
  // };

  const formConfig = CustomerInputs.filter((input) => {
    if (
      [
        "oldproduct",
        "oldvehiclename",
        "altmobile",
        "oldmake",
        "oldmodel",
      ].includes(input.name)
    ) {
      return showParentDesignation; // Include these inputs only if showParentDesignation is true
    }
    if (input.name === "altmobile") {
      return formData.leadsource === 2; // Include 'altmobile' only if leadsource is 2
    }
    return true; // Include all other inputs
  }).map((input) => {
    if (input.name === "leadsource") {
      return { ...input, options: leadSourceOptions };
    }
    if (input.name === "customertype") {
      return { ...input, options: customertypeOptions };
    }
    if (input.name === "title") {
      return { ...input, options: titleoptions };
    }
    if (input.name === "preferredlanguage") {
      return { ...input, options: languageoptions };
    }
    if (input.name === "status") {
      return { ...input, options: statusoptions };
    }
    if (input.name === "occupation") {
      return { ...input, options: OccupationOptions };
    }

    if (input.name === "leadpriority") {
      return { ...input, options: leadPriorityOptions };
    }
    if (input.name === "productname") {
      return { ...input, options: productOptions };
    }
    if (input.name === "oldproduct") {
      return { ...input, options: oldproductOptions };
    }
    if (input.name === "vehiclename") {
      return { ...input, options: variantOptions };
    }
    if (input.name === "oldvehiclename") {
      return { ...input, options: oldvariantOptions };
    }
    if (input.name === "fueltype") {
      return { ...input, options: fuelOptions };
    }
    if (input.name === "leadexecutive") {
      return { ...input, options: executiveoptions };
    }
    if (input.name === "branchcenter") {
      return { ...input, options: branchCenteroptions };
    }
    if (input.name === "branchcity") {
      return { ...input, options: showroomOptions };
    }
    if (input.name === "businesspartnername") {
      return { ...input, options: BusinessPartneroptions };
    }
    return input;
  });

  return (
    <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Update Lead</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Update Lead Details
        </span>

        <div></div>
        <DynamicForm
          formConfig={formConfig}
          // formConfig={CustomerInputs.map(input => {
          //   if (input.name === "leadsource") {
          //     return { ...input, options: leadSourceOptions };
          //   }
          //   if (input.name === "customertype") {
          //     return { ...input, options: customertypeOptions };
          //   }
          //   if (input.name === "title") {
          //     return { ...input, options: titleoptions };
          //   }
          //   if (input.name === "preferredlanguage") {
          //     return { ...input, options: languageoptions };
          //   }
          //   if (input.name === "status") {
          //     return { ...input, options: statusoptions };
          //   }
          //   if (input.name === "occupation") {
          //     return { ...input, options: OccupationOptions };
          //   }

          //   if (input.name === "leadpriority") {
          //     return { ...input, options: leadPriorityOptions };
          //   }
          //   if (input.name === "productname") {
          //     return { ...input, options: productOptions };
          //   }
          //   if (input.name === "oldproduct") {
          //     return { ...input, options: productOptions };
          //   }
          //   if (input.name === "vehiclename") {
          //     return { ...input, options: variantOptions };
          //   }
          //   if (input.name === "oldvehiclename") {
          //     return { ...input, options: variantOptions };
          //   }
          //   if (input.name === "fueltype") {
          //     return { ...input, options: fuelOptions };
          //   }
          //   if (input.name === "leadexecutive") {
          //     return { ...input, options: executiveoptions };
          //   }
          //   if (input.name === "branchcenter") {
          //     return { ...input, options: showroomOptions };
          //   }
          //   if (input.name === "businesspartnername") {
          //     return { ...input, options: BusinessPartneroptions };
          //   }
          //   return input;
          // })}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          showParentDesignation={showParentDesignation}
          setShowParentDesignation={setShowParentDesignation}
        />
      </div>

      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            handleFormSubmit(formData);
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default AddNewLead;
